import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { DashboardPage } from './pages/DashboardPage';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/login" element={<LoginPage data-id="element-6" />} data-id="element-5" />
          <Route path="/signup" element={<SignupPage data-id="element-8" />} data-id="element-7" />
          <Route path="/dashboard" element={<DashboardPage data-id="element-10" />} data-id="element-9" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-12" />} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>;
}